import * as React from 'react';
import classNames from '../../utilities/class-names';

const EditIcon = ({ className }) => {
    return (<svg width="16" height="16" viewBox="0 0 16 16" className={classNames('docs-icon', className)} xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M3 2V14H13V9.53609L14 8.53609V14C14 14.5531 13.5531 15 13 15H3C2.44687 15 2 14.5531 2 14V2C2 1.44687 2.44687 1 3 1H11L12.5034 2.50344L10 5V2H3ZM15 6.11875L15.7094 5.41562C16.0969 5.025 16.0969 4.3875 15.7094 4L15.0031 3.29375C14.6125 2.90625 13.975 2.90625 13.5875 3.29375L12.8813 4L15 6.11875ZM14.3875 6.73438L12.2656 4.6125L7.84062 9.0375L7 9.91562V12H9.08437L9.9625 11.1594L14.3875 6.73438ZM12.9719 6.73438L12.2656 6.02812L8.02187 10.2719L8.375 10.625L8.72813 10.9781L12.9719 6.73438ZM6 10H5V9H6V9.51412V10ZM5 8H8V7H5V8ZM5 5H9V6H5V5ZM5 12H6V11H5V12Z" />
        </g>
    </svg>
    )
}

export default EditIcon;